import { normalizeMapStyle } from './map-style.js';

export const TRACK_HEAD_ICONS = [
  { id: 'dot', label: 'Dot' },
] as const;
export const TRACK_HEAD_ICON_IDS = TRACK_HEAD_ICONS.map(icon => icon.id);
/** Older saved projects are accepted and normalized to the fixed dot. */
export const LEGACY_TRACK_HEAD_ICON_IDS = ['dot', 'arrow', 'bicycle', 'hiker', 'runner'] as const;
export type LegacyTrackHeadIcon = (typeof LEGACY_TRACK_HEAD_ICON_IDS)[number];
export type TrackHeadIcon = (typeof TRACK_HEAD_ICON_IDS)[number];
export const TRACK_WIDTH_LIMITS = { min: 1, max: 20 } as const;

/** Appearance shared by the studio, composition, and render jobs. */
export interface TrackAppearance {
  readonly color: string;
  readonly width: number;
  readonly headIcon: TrackHeadIcon;
}

/** Default colors for newly created compositions. */
export const NIGHT_HAWK_TRACE_COLOR = '#d8f368';
export const BLACKBIRD_TRACE_COLOR = '#39ff14';
export const HEAT_TRACE_COLOR = '#00e5ff';

export function defaultTrackAppearance(lineStyle: string, cameraPlatform?: string, mapStyle?: string): TrackAppearance {
  return { color: cameraPlatform === 'blackbird' ? BLACKBIRD_TRACE_COLOR : cameraPlatform === 'night-hawk' ? NIGHT_HAWK_TRACE_COLOR
    : normalizeMapStyle(mapStyle ?? 'mcnally') === 'heat' ? HEAT_TRACE_COLOR : lineStyle === 'standard' ? '#ffd43b' : '#f16929',
    width: lineStyle === 'standard' ? 8 : 10, headIcon: 'dot' };
}
